import { jsx } from "react/jsx-runtime";
import { memo, useState, useCallback } from "react";
import { ApiBaseUrlContext } from "./config/ApiBaseUrlContext.js";
import { LoginTokenContext } from "./config/LoginTokenContext.js";
import { SetSessionTokenContext } from "./auth/SetSessionTokenContext.js";
import { SessionTokenContext } from "./auth/SessionTokenContext.js";
import { ProjectSlugContext } from "./project/ProjectSlugContext.js";
import { StageSlugContext } from "./project/StageSlugContext.js";
const sessionTokenKey = "contember_session_token";
const ContemberClient = memo(function ContemberClient2({
  apiBaseUrl,
  children,
  loginToken,
  project,
  sessionToken,
  stage
}) {
  const [sessionTokenInner, setSessionTokenInner] = useState(() => localStorage.getItem(sessionTokenKey) ?? sessionToken ?? void 0);
  const setSessionToken = useCallback((token) => {
    if (token !== void 0) {
      localStorage.setItem(sessionTokenKey, token);
    } else {
      localStorage.removeItem(sessionTokenKey);
    }
    setSessionTokenInner(token);
  }, []);
  return /* @__PURE__ */ jsx(ApiBaseUrlContext.Provider, { value: apiBaseUrl, children: /* @__PURE__ */ jsx(LoginTokenContext.Provider, { value: loginToken, children: /* @__PURE__ */ jsx(SetSessionTokenContext.Provider, { value: setSessionToken, children: /* @__PURE__ */ jsx(SessionTokenContext.Provider, { value: sessionTokenInner, children: /* @__PURE__ */ jsx(ProjectSlugContext.Provider, { value: project, children: /* @__PURE__ */ jsx(StageSlugContext.Provider, { value: stage, children }) }) }) }) }) });
});
export {
  ContemberClient
};
//# sourceMappingURL=ContemberClient.js.map
